import React, { useState, useRef, ReactElement } from "react";
import "../../css/TeeStyles.css";

import "../../icons/assets/icon-1.png";
import { Icon } from "@iconify/react";
import imgFive from "../../icons/assets/img-5.png";
import serviceIcon from "../../icons/assets/service-1.png";

interface listTextItems<T, U, V> {
  images: T;
  text: U;
  marginBottom: V;
}

interface Image {
  id?: string | number;
  img: string;
  text?: string;
}

interface HoverImageProps {
  images: Image[];
}

interface AccordionList {
  id: any;
  title: String;
  content: String;
}
interface accordionDataContent<Ttitle, Tcontent> {
  title: Ttitle;
  content: Tcontent;
}

interface servicesList<T, U, V, X> {
  image: T;
  heading: U;
  subHeading: V;
  body: X;
}

interface serviceArray {
  servicesData: servicesList<string, string, string, string>[];
}

export const ListIconText = ({
  images,
  text,
  marginBottom,
}: listTextItems<String, String, String>): ReactElement => {
  const imagePath = require(`../../icons/assets/${images}`);
  return (
    <div
      className="container-img wid100Mobile"
      data-aos="fade-up"
      style={{ marginBottom: `${marginBottom}`, zIndex: 4 }}
    >
      <div
        style={{
          backgroundImage: `url(${imagePath})`,
          // padding: "1em",
        }}
        className="my-image-icon wid-list-items d-flex align-items-center white boldSeven fontSize32px"
      >
        <span className="d-block wid100 wid50Mobile text-center">{text}</span>
      </div>
    </div>
  );
};
interface accordionInt<Ttitle, Tcontent> {
  title: Ttitle;
  content: Tcontent;
}

interface AccordionProps {
  accordions: accordionInt<string, string>[];
}

export const Services: React.FC<serviceArray> = ({
  servicesData,
}): ReactElement => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      {servicesData.map((service, index) => (
        <div key={index} className="mb-5 py-md-3 py-3 wid100 bgWhite rounded-3">
          <img src={service.image} alt="" className="d-block mx-auto" />
          <span className="fontSize36px boldSeven d-block text-center blackKsb mt-2">
            {service.heading}
          </span>
          <span className="fontSize16px boldFour d-block text-center blackKsb mx-auto mt-2 wid20Mobile wid40">
            {service.subHeading}
          </span>
          <span
            onClick={() => handleToggle(index)}
            style={{ color: "red", borderBottom: "red solid 1px" }}
            className="fontSize16px boldFour d-block text-center mx-auto mt-2 mb-2 wid10 wid10Mobile pointers"
          >
            View {activeIndex === index ? "Less" : "More"}
          </span>
          {activeIndex === index && (
            <div style={{ border: "2px #dddddd solid" }}></div>
          )}
          {activeIndex === index && (
            <div className="px-3 py-5">
              <span className="d-block fontSize16px wid80 wid50Mobile mx-auto text-justify">
                {service.body}
              </span>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export const Accordion: React.FC<AccordionProps> = ({
  accordions,
}): ReactElement => {
  // Initialize an array of boolean values, one for each accordion item.
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  // Toggle accordion state when clicked
  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index); // Close if open, open if closed
  };

  return (
    <>
      {accordions.map((accordion, index) => (
        <div key={index} className="accordion-item mcm-dark-bg">
          <div className="accordion-title" onClick={() => handleToggle(index)}>
            <div className="white fontSize16px boldSeven">
              {accordion.title}
            </div>
            <span className="white fontSize24px">
              {activeIndex === index ? "-" : "+"}
            </span>
          </div>
          {activeIndex === index && (
            <div
              className="accordion-content white boldThree fontSize16px"
              dangerouslySetInnerHTML={{ __html: accordion.content }}
            ></div>
          )}
        </div>
      ))}
    </>
  );
};

export const accordionData: accordionDataContent<string, string>[] = [
  {
    title: "What services does MCM Studio offer?",
    content: `MCM Studio offers a comprehensive range of creative services, including: 
    <br><br>Podcast Production: Professional podcast recording, and editing, including studio rental and expert guidance.
    <br><br>Photography Space: High-quality photography space for photoshoots, commercial photography, and for photographers to hone their skills.
    <br><br>Seminar and Event Space: Elegant, versatile seminar space rental for workshops, training sessions, and corporate events.Audio-Visual Rentals: State-of-the-art audio-visual equipment rental within the studio premise`,
  },
  {
    title: "How much does your service cost?",
    content: `Our service depends on the service package: <br>
        <br>Podcast Package Rate
        <br>Photography and Videography Rate 
        <br>Seminar/ Training Space Rate
      `,
  },
  {
    title: "How much does it cost to book a podcast studio space?",
    content: `Our podcast studio rental packages vary based on the number of hours, and scope of services. However our basic package starts at ₦50,000`,
  },
  {
    title: "How can I book a Seminar Space?",
    content: `Booking our seminar space is easy and convenient. Click on "Book A session" to book your space.`,
  },
  {
    title: "Is there a photography space for photoshoots?",
    content: `Yes, there is! Our studio offers a spacious and well-equipped photography space perfect for photoshoots. Our facility features:<br>
      - Professional lighting equipment
      <br>- Versatile backdrops and sets
`,
  },
  {
    title: "Do you offer equipment rental?",
    content: `MCM Studio provides a variety of equipment for rent, but please note that all equipment must be used exclusively within our studio premises. Off-site usage is not permitted.`,
  },
];

export const servicesData: servicesList<string, string, string, string>[] = [
  {
    image: serviceIcon,
    heading: "Podcasting",
    subHeading:
      "High-quality audio production with professional studio setups and editing.",
    body: `Full Studio Rental: Enjoy a comfortable and professional recording space, fully equipped with soundproofing and high-end audio gear to ensure impeccable sound quality.

      Video Podcasting: Go beyond audio with single or multi-camera setups to capture visually engaging podcast episodes, perfect for video platforms.

      High-Quality Microphones: Choose from a range of lapel mics, boom mics, and other specialized audio equipment for crystal-clear recordings that sound polished and professional.

      Remote Guest Integration: Seamlessly integrate virtual guests into your podcast with our advanced virtual setup, allowing you to host interviews from around the world with zero hassle.

      Post-Production Editing: Our skilled editors fine-tune your recordings, removing background noise, balancing audio levels, and adding final touches to ensure a professional finish.`,
  },
  {
    image: serviceIcon,
    heading: "Seminars",
    subHeading:
      "High-quality audio production with professional studio setups and editing.",
    body: `Full Studio Rental: Enjoy a comfortable and professional recording space, fully equipped with soundproofing and high-end audio gear to ensure impeccable sound quality.

      Video Podcasting: Go beyond audio with single or multi-camera setups to capture visually engaging podcast episodes, perfect for video platforms.

      High-Quality Microphones: Choose from a range of lapel mics, boom mics, and other specialized audio equipment for crystal-clear recordings that sound polished and professional.

      Remote Guest Integration: Seamlessly integrate virtual guests into your podcast with our advanced virtual setup, allowing you to host interviews from around the world with zero hassle.

      Post-Production Editing: Our skilled editors fine-tune your recordings, removing background noise, balancing audio levels, and adding final touches to ensure a professional finish.`,
  },
  {
    image: serviceIcon,
    heading: "Photography",
    subHeading:
      "High-quality audio production with professional studio setups and editing.",
    body: `Full Studio Rental: Enjoy a comfortable and professional recording space, fully equipped with soundproofing and high-end audio gear to ensure impeccable sound quality.

      Video Podcasting: Go beyond audio with single or multi-camera setups to capture visually engaging podcast episodes, perfect for video platforms.

      High-Quality Microphones: Choose from a range of lapel mics, boom mics, and other specialized audio equipment for crystal-clear recordings that sound polished and professional.

      Remote Guest Integration: Seamlessly integrate virtual guests into your podcast with our advanced virtual setup, allowing you to host interviews from around the world with zero hassle.

      Post-Production Editing: Our skilled editors fine-tune your recordings, removing background noise, balancing audio levels, and adding final touches to ensure a professional finish.`,
  },
  {
    image: serviceIcon,
    heading: "Video Production",
    subHeading:
      "High-quality audio production with professional studio setups and editing.",
    body: `Full Studio Rental: Enjoy a comfortable and professional recording space, fully equipped with soundproofing and high-end audio gear to ensure impeccable sound quality.

      Video Podcasting: Go beyond audio with single or multi-camera setups to capture visually engaging podcast episodes, perfect for video platforms.

      High-Quality Microphones: Choose from a range of lapel mics, boom mics, and other specialized audio equipment for crystal-clear recordings that sound polished and professional.

      Remote Guest Integration: Seamlessly integrate virtual guests into your podcast with our advanced virtual setup, allowing you to host interviews from around the world with zero hassle.

      Post-Production Editing: Our skilled editors fine-tune your recordings, removing background noise, balancing audio levels, and adding final touches to ensure a professional finish.`,
  },
];

export const HoverImages: React.FC<HoverImageProps> = ({
  images,
}): ReactElement => {
  return (
    <>
      {images.map((image) => (
        <div
          key={image.id}
          className="container-hover position-relative mt-4 mx-3"
        >
          <img src={image.img} alt="Avatar" className="image-hover" />
          <div className="overlay-hover rounded-4">
            <div className="text-hover fontSize20px">{image.text}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export const HorizontalScroll: React.FC<HoverImageProps> = ({
  images,
}): ReactElement => {
  // Reference to the scrollable div
  const scrollRef = useRef<HTMLDivElement>(null);

  // Function to scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  // Function to scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <div className="d-md-none mt-4 d-block px-4 position-relative">
      <button
        onClick={scrollLeft}
        className="border-none fontSize32px position-absolute bg-none p-2 bgSocials rounded-circle"
        style={{ top: "40%", left: "1%" }}
      >
        <Icon icon="solar:alt-arrow-left-broken" />
      </button>
      <div
        ref={scrollRef}
        style={{
          display: "flex",
          overflowX: "hidden",
          scrollBehavior: "smooth",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        {images.map((image, index) => (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img
            key={index}
            src={image.img}
            alt={`Image ${index}`}
            style={{
              width: "auto",
              height: "auto",
              marginRight: "10px",
            }}
          />
        ))}
      </div>
      <button
        onClick={scrollRight}
        className="border-none fontSize32px position-absolute bg-none p-2 text-center bgSocials rounded-circle"
        style={{ top: "40%", right: "1%" }}
      >
        <Icon icon="solar:alt-arrow-right-broken" />
      </button>
    </div>
  );
};

export function convertTo12Hour(time: string): string {
  // Split the time into hours and minutes
  let [hours, minutes] = time.split(":").map(Number);

  // Determine AM or PM suffix
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12 || 12; // Convert 0 to 12 for midnight and handle noon

  // Return the formatted time string
  return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
}
